export default "__VITE_ASSET__xTZ8c8$a__"